<template>
  <div class="font-style-button">
    <button type="button" :class="{ active: values.weight === 'bold' }" @click="boldSubmit">
      <Bold />
    </button>
    <button type="button" :class="{ active: values.fontStyle === 'italic' }" @click="italicSubmit">
      <Italic />
    </button>
    <button type="button" :class="{ active: values.decoration === 'underline' }" @click="underlineSubmit">
      <Underline />
    </button>
    <button type="button" :class="{ active: values.decoration === 'line-through' }" @click="strikethroughSubmit">
      <Strikethrough />
    </button>
  </div>
</template>

<script>
import Bold from '../../assets/text-buttons/bold.svg'
import Italic from '../../assets/text-buttons/italic.svg'
import Strikethrough from '../../assets/text-buttons/strikethrough.svg'
import Underline from '../../assets/text-buttons/underline.svg'

export default {
  name: 'FontStyleButton',
  props: {
    values: {
      type: Object,
    },
    text: {
      type: String,
      default: '',
    },
  },
  components: {
    Bold,
    Italic,
    Strikethrough,
    Underline,
  },
  methods: {
    async boldSubmit() {
      const value = await (this.values.weight === 'normal' ? 'bold' : 'normal')
      const path = `${this.text}.weight`
      this.$emit('change', { path, value })
    },
    italicSubmit() {
      const value = this.values.fontStyle === 'normal' ? 'italic' : 'normal'
      const path = `${this.text}.fontStyle`
      this.$emit('change', { path, value })
    },
    underlineSubmit() {
      const value =
        this.values.decoration === 'none' || this.values.decoration === 'line-through' ? 'underline' : 'none'
      const path = `${this.text}.decoration`
      this.$emit('change', { path, value })
    },
    strikethroughSubmit() {
      const value =
        this.values.decoration === 'none' || this.values.decoration === 'underline' ? 'line-through' : 'none'
      const path = `${this.text}.decoration`
      this.$emit('change', { path, value })
    },
  },
}
</script>

<style scoped lang="scss">
.font-style-button {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-around;

  > button {
    width: 100%;
    display: flex;
    box-sizing: border-box;

    padding: 10px;
    justify-content: center;
    align-items: center;

    background: #ffffff;
    border: 0;

    &:hover {
      background: rgba(0, 0, 0, 0.2);
      svg {
        path {
          fill: #ff305c;
        }
      }
    }
  }

  > button + button {
    border-left: 1px solid #d9d9d9;
  }

  > .active {
    background: #f8f8f8;
    border: 1px solid #d9d9d9;
    svg {
      path {
        fill: #ff305c;
      }
    }
  }
}
</style>
